export const APP_VERSION = "1.39.5";
